module.exports = __webpack_public_path__ + "img/物流-运单.14dc564f.jpg";